import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaRegCommentDots,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./contactjs.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

const Contactus = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [pathname]);
  return (
    <div>
      {/* Header */}
      <Header />

      <Container className="contact-section py-5">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h6 className="text-muted">You can</h6>
          <h2 className="fw-bold mb-4">Contact Us</h2>

          <div className="contact-box">
            <Row className="g-4">
              {/* LEFT FORM */}
              <Col lg={5} md={12}>
                <h5 className="fw-semibold mb-2">Enter Your Details</h5>
                <p className="text-muted mb-4">
                  We're here to help & answer any questions you might have.
                </p>

                <Form>
                  {[
                    {
                      icon: <FaUser />,
                      placeholder: "Please enter your full name",
                    },
                    {
                      icon: <FaEnvelope />,
                      placeholder: "Please enter your Email address",
                    },
                    {
                      icon: <FaPhoneAlt />,
                      placeholder: "Please enter your phone number",
                    },
                  ].map((field, i) => (
                    <motion.div
                      key={i}
                      whileFocus={{ scale: 1.02 }}
                      className="input-box"
                    >
                      <span>{field.icon}</span>
                      <Form.Control placeholder={field.placeholder} />
                    </motion.div>
                  ))}

                  <motion.div
                    whileFocus={{ scale: 1.02 }}
                    className="input-box textarea"
                  >
                    <span>
                      <FaRegCommentDots />
                    </span>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Please enter your message"
                    />
                  </motion.div>

                  <motion.button
                    className="submit-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Submit →
                  </motion.button>
                </Form>
              </Col>

              {/* RIGHT INFO + MAP */}
              <Col lg={7} md={12}>
                <div className="office-info mb-3">
                  <FaMapMarkerAlt className="icon" />
                  <div>
                    <h6 className="fw-semibold">Head Office</h6>
                    <p>
                      Crescent House, B/h. Navrangpura Post Office, Navrangpura
                      Rd, Mithakhali, Navrangpura, Ahmedabad, Gujarat 380009
                    </p>
                  </div>
                </div>

                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Phone</strong>
                    <p>+91 8340-088888</p>
                  </Col>
                  <Col md={6}>
                    <strong>Email</strong>
                    <p>contactus@example.com</p>
                  </Col>
                </Row>

                <motion.iframe
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d36141.270184255365!2d72.51086012096431!3d23.042339758002882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84f53fffffff%3A0xa54e184aaa583f99!2sCrescent%20Electronics%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1770724004870!5m2!1sen!2sin"
                  className="map"
                  loading="lazy"
                />
              </Col>
            </Row>
          </div>
        </motion.div>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contactus;
